import { AxiosError } from 'axios'
import { ApiProvider } from '../provider'
import { APIRoutes } from '../routes'
import { PageType } from 'api/types/page'
import { UploadFile } from 'pages/Admin/Product'

class Page {
  // get all pages
  async getPageList(): Promise<PageType[] | (AxiosError | Error)> {
    const url = `${APIRoutes.page.getPageList}`
    return ApiProvider.getRequest(url) as Promise<
      PageType[] | (AxiosError | Error)
    >
  }

  // fetch a single page by id
  async getPage({
    id,
  }: {
    id: number
  }): Promise<PageType | (AxiosError | Error)> {
    const url = `${APIRoutes.page.getPage}?id=${id}`
    return ApiProvider.getRequest(url) as Promise<
      PageType | (AxiosError | Error)
    >
  }

  async getPageBySlug({
    slug,
  }: {
    slug: string
  }): Promise<PageType | (AxiosError | Error)> {
    const url = `${APIRoutes.page.getPageBySlug}?slug=${slug}`
    return ApiProvider.getRequest(url) as Promise<
      PageType | (AxiosError | Error)
    >
  }

  // delete a page
  async deletePage({ id }: { id: number }): Promise<any | AxiosError | Error> {
    const url = `${APIRoutes.page.deletePage}?id=${id}`
    return ApiProvider.deleteRequest(url) as Promise<any | AxiosError | Error>
  }

  // create or update a page
  async savePage({
    id,
    title,
    slug,
    content,
    active,
  }: PageType): Promise<any | AxiosError | Error> {
    const url = APIRoutes.page.savePage
    const body = new FormData()
    if (id) body.append('id', String(id))
    if (title) body.append('title', title)
    if (content) body.append('content', content)
    if (slug) body.append('slug', slug)
    if (active) body.append('active', active ? 'true' : 'false')
    body.append('active', active ? 'true' : 'false')

    return ApiProvider.postRequest(url, body, true) as Promise<
      any | AxiosError | Error
    >
  }

  // add pages files
  async addPageFiles({
    id,
    file,
  }: {
    id: string
    file: UploadFile
  }): Promise<string | AxiosError | Error> {
    const url = APIRoutes.page.addPageFiles
    const formData = new FormData()
    formData.append('id', id)
    formData.append(`files[0].File`, file.file)
    formData.append(`files[0].label`, file.label)
    return ApiProvider.postRequest(url, formData, true) as Promise<
      string | AxiosError | Error
    >
  }

  // remove page file
  async removePageFile({
    pageId,
    fileId,
  }: {
    pageId: string
    fileId: string
  }): Promise<any | AxiosError | Error> {
    const url = `${APIRoutes.page.removePageFile}?pageId=${pageId}&fileId=${fileId}`
    return ApiProvider.deleteRequest(url) as Promise<any | AxiosError | Error>
  }

  // add page Q&A
  async addPageQAs({
    pageId,
    question,
    answer,
  }: {
    pageId: number
    question: string
    answer: string
  }): Promise<any | AxiosError | Error> {
    const url = APIRoutes.page.addPageQA

    const formData = new FormData()
    formData.append('pageId', pageId.toString())
    formData.append('question', question)
    formData.append('answer', answer)

    return ApiProvider.postRequest(url, formData, true) as Promise<
      any | AxiosError | Error
    >
  }

  async removePageQA({
    pageId,
    qaId,
  }: {
    pageId: string
    qaId: string
  }): Promise<any | AxiosError | Error> {
    const url = `${APIRoutes.page.removePageQA}?pageId=${pageId}&qaId=${qaId}`
    return ApiProvider.deleteRequest(url) as Promise<any | AxiosError | Error>
  }
}

export const pageService = new Page()
